import React, { useRef, useState } from "react";

import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faAngleUp,
  faEye,
} from "@awesome.me/kit-c1b85ff10f/icons/classic/light";
import moment from "moment";

import { List } from "../../Components/common/List/List";
import { ListProvider } from "../../Components/common/List/Providers/List";
import { dictionary } from "../../utilities/dictionary";
import { useAppContext } from "../../AppProvider";
import { useListProps } from "./utilities/list";
import { TooltipCopy } from "../../Components/common/Tooltips/TooltipCopy";
import { Collapse } from "reactstrap";

const CODCollectionShipments = ({ parentId }) => {
  const listRef = useRef(null);
  const listProps = useListProps();

  const renderItem = (item, key) => {
    return <ListItem item={item} index={key} />;
  };

  return (
    <React.Fragment>
      <ListProvider
        path={listProps.path}
        parentId={parentId}
        sorting={listProps.sorting}
        filters={listProps.filters}
        defaultDate={listProps.defaultDate}
      >
        <List
          ref={listRef}
          title={listProps.title}
          create={listProps.create}
          banner={listProps.banner}
          massiveActions={listProps.massiveActions}
          omnisearch={listProps.omnisearch}
          exports={listProps.exports}
          renderItem={renderItem}
        />
      </ListProvider>
    </React.Fragment>
  );
};

export default CODCollectionShipments;

const ListItem = React.memo(({ item, index }) => {
  const [isOpen, setIsOpen] = useState(false);

  const { dictionary } = useAppContext();

  return (
    <React.Fragment key={index}>
      <div className="list-item px-2">
        <div
          className=" d-grid align-items-center"
          style={{
            gridAutoFlow: "column",
            gridTemplateColumns: `1.25fr 2.5fr 3fr 1fr 1fr 0.5fr 1fr 0.75fr`,
            gap: "0.5rem",
          }}
        >
          <div>
            <TooltipCopy
              target={"internalReference_" + index}
              textToCopy={item.shipment?.internalReference}
            >
              <label className="label-4 cursor-pointer">
                {item.shipment?.internalReference}
              </label>
            </TooltipCopy>
            <span className="span-1">
              {moment(item.shipment?.creationDate).format("DD/MM/YYYY")} |{" "}
              {moment(item.shipment?.creationDate).format("HH:mm")}
            </span>
          </div>
          <div
            className="bg-grey d-grid grid-column"
            style={{
              gridTemplateColumns: `1fr 1fr`,
            }}
          >
            <div>
              <label className="label-2">
                {dictionary.references.carrier_reference}:
              </label>
              <TooltipCopy
                target={"carrier_reference_" + index}
                textToCopy={item.shipment?.carrierReference}
              >
                <label
                  className={`label-3 text-break ${
                    item.shipment?.carrierReference ? "cursor-pointer" : ""
                  }`}
                >
                  {item.shipment?.carrierReference || "-"}
                </label>
              </TooltipCopy>
            </div>
            <div>
              <label className="label-2">
                {dictionary.references.external_reference}:
              </label>
              <TooltipCopy
                target={"external_reference_" + index}
                textToCopy={item.shipment?.externalReference}
              >
                <label
                  className={`label-3 text-break ${
                    item.shipment?.externalReference ? "cursor-pointer" : ""
                  }`}
                >
                  {item.shipment?.externalReference || "-"}
                </label>
              </TooltipCopy>
            </div>
          </div>
          <div>
            <label className="label-2">{dictionary.registries.receiver}:</label>
            <label className={`label-3`}>
              {item.shipment?.deliveryName || "-"}
            </label>
          </div>
          <div>
            <label className="label-2">
              {dictionary.dimensions.expected_amount}:
            </label>
            <label className="label-3">
              {item.expectedAmount
                ? `${item.expectedAmount.toFixed(2)} €`
                : "-"}
            </label>
          </div>
          <div>
            <label className="label-2">
              {dictionary.dimensions.collected_amount}:
            </label>
            <label className="label-3">
              {item.collectedAmount
                ? `${item.collectedAmount.toFixed(2)} €`
                : "-"}
            </label>
          </div>
          <div>
            <label className="label-2">{dictionary.words.delta}:</label>
            <label
              className={`label-3 ${
                item.collectedAmount - item.expectedAmount >= 0
                  ? "text-success"
                  : "text-danger"
              }`}
            >
              {item.collectedAmount && item.expectedAmount
                ? `${(item.collectedAmount - item.expectedAmount).toFixed(2)} €`
                : "-"}
            </label>
          </div>
          <div>
            <label className="label-2">
              {dictionary.dates.collected_date}:
            </label>
            <label className="label-3">
              {item.collectionDate
                ? moment(item.collectionDate).format("DD/MM/YYYY")
                : "-"}
            </label>
          </div>
          <div className="text-end">
            <Link
              className="button-1 button-1-light button-1-icon me-2"
              to={`/shipments/details/${item.shipment?.id}`}
              title={dictionary.actions.details}
            >
              <FontAwesomeIcon icon={faEye} />
            </Link>
            {isOpen ? (
              <FontAwesomeIcon
                className="cursor-pointer"
                icon={faAngleUp}
                onClick={() => setIsOpen(!isOpen)}
                title={dictionary.actions.reduce}
              />
            ) : (
              <FontAwesomeIcon
                className="cursor-pointer"
                icon={faAngleDown}
                onClick={() => setIsOpen(!isOpen)}
                title={dictionary.actions.expand}
              />
            )}
          </div>
        </div>

        <Collapse
          isOpen={isOpen}
          className="accordion-collapse mt-2"
          aria-controls="true"
        >
          <div
            className=" d-grid align-items-center"
            style={{
              gridAutoFlow: "column",
              gridTemplateColumns: `1fr 1fr 0.5fr`,
              gap: "0.5rem",
            }}
          >
            <div>
              <label className="label-2">{dictionary.registries.sender}:</label>
              <label className={`label-3`}>
                {item.shipment?.senderName || "-"}
              </label>
            </div>

            <div>
              <label className="label-2">{dictionary.words.note}:</label>
              <label className={`label-3`}>{item.shipment?.note || "-"}</label>
            </div>
          </div>
        </Collapse>
      </div>
    </React.Fragment>
  );
});
